module.exports = __webpack_public_path__ + "static/media/boats.ee6247e6.jpg";